import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-promocode-analytics',
  templateUrl: './promocode-analytics.component.html',
  styleUrls: ['./promocode-analytics.component.scss']
})
export class PromocodeAnalyticsComponent implements OnInit {

  constructor() { }

  @Input() promocode:any = [];
  @Input() currencySymbol:any;

  ngOnInit(): void {
  }

}
